var exports = {
  "kL": "xa15a2ab7--19e637--container",
  "Lp": "xa15a2ab7--19e637--uplayer",
  "oH": "xa15a2ab7--19e637--no-scroll",
  "Y5": "xa15a2ab7--19e637--fullscreen",
  "R": "xa15a2ab7--19e637--hidden",
  "pq": "xa15a2ab7--19e637--info",
  "_R": "xa15a2ab7--19e637--close-button",
  "V9": "xa15a2ab7--19e637--info-section",
  "VY": "xa15a2ab7--19e637--info-block",
  "uB": "xa15a2ab7--19e637--contact-button",
  "Up": "xa15a2ab7--19e637--view",
  "L0": "xa15a2ab7--19e637--fullscreen-button",
};

module.exports = exports;
